export const UnknownLocationPlaceholder = "Location Unknown";

export function getLocationWithPlaceholder(
    location: string | null | undefined,
): string {
    return location || UnknownLocationPlaceholder;
}
